import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { URL_PAYMENTCERT_HISTORY, URL_PAYMENTCERT_REGISTER } from '@app/@core/constants/routes.constants';
import { CredentialsService, AuthenticationService } from '@app/login';

@Injectable({
  providedIn: 'root',
})
export class PaymentGuard implements CanActivate {
  constructor(
    readonly router: Router,
    readonly credentialsService: CredentialsService,
    readonly authenticationService: AuthenticationService
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.credentialsService.isAuthenticated()) {
      if (
        (state.url === URL_PAYMENTCERT_REGISTER && this.authenticationService.isPaymentCertifications()) ||
        (state.url === URL_PAYMENTCERT_HISTORY && this.authenticationService.isPaymentCertifications())
      ) {
        return true;
      } else {
        this.router.navigate(['/**'], { replaceUrl: true });
        return false;
      }
    } else {
      this.router.navigate(['/**'], { replaceUrl: true });
    }
  }
}
